import {getPorts} from 'providers/ferries/api';
import FerrySearchMaskStore from './store';
import {searchMaskTranslations} from 'ferries/helpers/translations';
import {brand} from 'helpers/stableValues';

export default function createSearchMaskStore() {
  return new FerrySearchMaskStore({
    getPorts,
    brand,
    translations: searchMaskTranslations
  });
}
